export default {
  tabProducts: {
    id: 'catalog_bulk_actions_tab_products',
    defaultMessage: 'Products',
  },
}
